import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Settings as SettingsIcon, Mail, Sparkles, Database, FileText, Building2, BookOpen, Key, Link2, Shield, Globe } from 'lucide-react';

export default function Settings() {
  const location = useLocation();

  // If at /settings, redirect to /settings/email by default
  if (location.pathname === '/settings') {
    window.location.href = '/settings/email';
  }

  return (
    <div className="flex gap-6">
      {/* Side Menu */}
      <div className="w-64 flex-shrink-0">
        <div className="bg-white rounded-lg shadow-sm border p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <SettingsIcon size={20} />
            Systeminnstillinger
          </h2>
          <nav className="space-y-1">
            <SideNavLink to="/settings/email" icon={<Mail size={18} />}>
              E-postinnstillinger
            </SideNavLink>
            <SideNavLink to="/settings/ai-prompts" icon={<Sparkles size={18} />}>
              KI-prompts
            </SideNavLink>
            <SideNavLink to="/settings/api" icon={<Key size={18} />}>
              API-integrasjoner
            </SideNavLink>
            <SideNavLink to="/settings/integrations" icon={<Link2 size={18} />}>
              LMS-integrasjoner
            </SideNavLink>
            <SideNavLink to="/settings/legal" icon={<FileText size={18} />}>
              Juridiske tekster
            </SideNavLink>
            <SideNavLink to="/settings/backup" icon={<Database size={18} />}>
              Sikkerhetskopier
            </SideNavLink>
            <SideNavLink to="/settings/esco" icon={<Globe size={18} />}>
              ESCO Taksonomi
            </SideNavLink>
            <SideNavLink to="/settings/devices" icon={<Shield size={18} />}>
              Mine enheter
            </SideNavLink>
            <SideNavLink to="/settings/account" icon={<Building2 size={18} />}>
              Konto
            </SideNavLink>
            <SideNavLink to="/settings/documentation" icon={<BookOpen size={18} />}>
              Dokumentasjon
            </SideNavLink>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}

function SideNavLink({ to, icon, children }: { to: string; icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          isActive
            ? 'bg-kf-primary text-white'
            : 'text-gray-700 hover:bg-gray-100'
        }`
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}
